import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { Dynamic, type DynamicAction } from '@shared/registry';

import type { ListMenuConfig, ListMenuItem } from './list-menu.types';

@Component({
  selector: 'app-list-menu',
  templateUrl: './list-menu.html',
  imports: [Dynamic],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListMenu {
  readonly config = input.required<ListMenuConfig>();
  readonly disabled = input<boolean>(false);

  readonly action = output<DynamicAction>();

  protected onItemClick(item: ListMenuItem): void {
    this.action.emit(item.action);
  }
}
